import { z } from 'zod';
import { AchBankAccountPayloadSchema } from './ach.bank-account.payload.entity';
import { AcssBankAccountPayloadSchema } from './acss.bank-account.payload.entity';
import { BacsBankAccountPayloadSchema } from './bacs.bank-account.payload.entity';
import { BecsBankAccountPayloadSchema } from './becs.bank-account.payload.entity';
import { CnapsBankAccountPayloadSchema } from './cnaps.bank-account.payload.entity';
import { FpsBankAccountPayloadSchema } from './fps.bank-account.payload.entity';
import { IbanBankAccountPayloadSchema } from './iban.bank-account.payload.entity';
import { IntradagclearingBankAccountPayloadSchema } from './intradagclearing.bank-account.payload.entity';
import { MepsBankAccountPayloadSchema } from './meps.bank-account.payload.entity';
import { RtgsBankAccountPayloadSchema } from './rtgs.bank-account.payload.entity';
import { SgdSwiftBankAccountPayloadSchema } from './sgd-swift.bank-account.payload.entity';
import { SwiftWithIbanBankAccountPayloadSchema } from './swift-with-iban.bank-account.payload.entity';
import { SwiftBankAccountPayloadSchema } from './swift.bank-account.payload.entity';

export const BankAccountPayloadSchema = z.union([
    BecsBankAccountPayloadSchema,
    AchBankAccountPayloadSchema,
    BacsBankAccountPayloadSchema,
    IbanBankAccountPayloadSchema,
    SwiftBankAccountPayloadSchema,
    AcssBankAccountPayloadSchema,
    CnapsBankAccountPayloadSchema,
    SwiftWithIbanBankAccountPayloadSchema,
    FpsBankAccountPayloadSchema,
    IntradagclearingBankAccountPayloadSchema,
    SgdSwiftBankAccountPayloadSchema,
    MepsBankAccountPayloadSchema,
    RtgsBankAccountPayloadSchema,
]);
